import React,{useEffect} from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({children}) => {
    let token =  localStorage.getItem('auth_token') || false;
    return token ? children : <Navigate to='/login'/>;
}
export default PrivateRoute;